import React from 'react'
import PropTypes from 'prop-types'
import { localize, localizeWithVars } from 'helpers/translator/localize'
import Confirm from 'views/confirm/confirm'

const MaxPresentationSizeReachedContactConfirm = props => (
	<Confirm
		btTwo={localize('max_presentation_size_reached__contact_button_text')}
		alertMessage={localizeWithVars('max_presentation_size_reached__contact_text', { maxSizeOfPresentations: props.maxSizeOfPresentations })}
		actionButtonType={0}
		actionTwo={props.acceptConfirmSelected}
		closeAction={props.closeConfirmSelected}
	/>
)

MaxPresentationSizeReachedContactConfirm.propTypes = {
	acceptConfirmSelected: PropTypes.func,
	closeConfirmSelected: PropTypes.func,
	maxSizeOfPresentations: PropTypes.string,
}

MaxPresentationSizeReachedContactConfirm.defaultProps = {
	acceptConfirmSelected: () => {},
	closeConfirmSelected: () => {},
	maxSizeOfPresentations: '',
}

export default MaxPresentationSizeReachedContactConfirm
